export const THEME_SPACING_UNIT = 3;

export const DEFAULT_COMPONENT_PADDING = '6px';

export const DEFAULT_COMPONENT_MARGIN = '6px';
